<template>
  <button :aria-label="ariaLabel" data-testid="back-button" @click="handleBack">
    <i class="icon" :class="iconClasses"></i>
    <slot></slot>
  </button>
</template>

<script setup>
import { useMobileNav } from '~/composables/useMobileNav';
import { tagNavLinkClick } from '#shared/features/analytics/navigationTags';

const props = defineProps({
  ariaLabel: {
    type: String,
    required: false,
    default: 'back to previous section',
  },
  iconClasses: {
    type: Object,
    required: true,
  },
});

const envProps = useEnvProps();
const pageData = usePageData();

const isMcom = envProps.isMcom;
const { context } = pageData.navigation;
const { back, analytics } = useMobileNav();

function fireAnalyticsEvent() {
  tagNavLinkClick(isMcom, {
    categoryId: analytics.getCategoryId(),
    context,
    topCategoryName: '',
    col: analytics.getCol(),
    pos: analytics.getLinkPosition(),
    clickableElement: props.title,
  });
}

function handleBack() {
  if (isMcom) fireAnalyticsEvent();
  back();
}
</script>

<style lang="scss" scoped brand="mcom">
.button-back {
  position: sticky;
  top: 0;
  background-color: $white;
  z-index: 2;
}
</style>

<style lang="scss" scoped>
.button-back {
  width: 100%;
  height: 71px;
  border-bottom: $hr-gray-divider;
  border-radius: 0;
  padding-left: 24px;

  .icon {
    position: absolute;
    left: 0;
    top: 24px;
    bottom: 24px;
  }
}

@include breakpoint(medium down) {
  .button-back {
    align-items: center;
    border: 0;
    display: flex;
    padding-left: 35px;
    position: relative;
    background-color: $gray-5-color;

    :deep(h5) {
      font-size: rem-calc(14);
      font-weight: 700;
      line-height: rem-calc(19);
      letter-spacing: -0.14px;
    }
  }
}
</style>

<style lang="scss" scoped brand="bcom">
.button-back {
  position: relative;
}

@include breakpoint(medium down) {
  .button-back {
    :deep(h5) {
      text-transform: uppercase;
    }
  }
}
</style>
